var map = {
	"./product_banner_building.png": "f177",
	"./product_banner_digital.png": "ece2",
	"./product_banner_energy.png": "3d2f",
	"./product_banner_fmcs.png": "42cf",
	"./product_banner_jidian.png": "4059",
	"./product_banner_robot.png": "0b59"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fc9f";